import { useFirmContext } from '../providers/FirmProvider';
import { SubscriptionStatus } from '../types/firm';

export function useIsActiveSubscription(): boolean {
    const { subscription } = useFirmContext();
    return subscription?.status === SubscriptionStatus.ACTIVE || subscription?.status === SubscriptionStatus.TRIALING;
}
